import { render, staticRenderFns } from "./Xzlist.vue?vue&type=template&id=6307dbb1&scoped=true"
import script from "./Xzlist.vue?vue&type=script&lang=js"
export * from "./Xzlist.vue?vue&type=script&lang=js"
import style0 from "./Xzlist.vue?vue&type=style&index=0&id=6307dbb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6307dbb1",
  null
  
)

export default component.exports